module.exports = __webpack_public_path__ + "img/345.04043508.png";